import { useEffect, useState } from 'react';
import { userApi } from '../api/user.api';
import { BASE_MEDIA_URL } from '../api/client';

/** Loads the logged-in account's saved pictorial signature URL. */
export default function useUserSignature() {
  const [signatureUrl, setSignatureUrl] = useState(null);
  const [signatureText, setSignatureText] = useState('');

  useEffect(() => {
    let cancelled = false;
    userApi.getSignature()
      .then((r) => {
        if (cancelled) return;
        const data = r.data || {};
        if (data.file_name) setSignatureUrl(`${BASE_MEDIA_URL}${data.file_name}`);
        if (data.signature_text) setSignatureText(data.signature_text);
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  return { signatureUrl, signatureText };
}
